import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import ChannelService from "../ChannelService";
import { tokenState } from "../state";
import CryptoJS from "crypto-js";
import { decodeToken } from "../utils/authUtil";

const ChannelTalk = () => {
  const token = useRecoilValue(tokenState);

  useEffect(() => {
    const accessToken = token && token.access_token && decodeToken(token.access_token);

    if (accessToken) {
      // TODO: memberHash 서버에서 내려받도록 변경
      const hash = CryptoJS.HmacSHA256(
        accessToken.sub,
        CryptoJS.enc.Hex.parse("6e7f73b95ce7d8a9a3ecd74d012c548257aa627659db3e62583b3ca9f704750b"),
      ).toString(CryptoJS.enc.Hex);

      const env = import.meta.env.VITE_APP_ARG;

      ChannelService.boot({
        pluginKey: "14123e3e-8cd8-4698-98a9-3af097115ea5",
        memberId: accessToken.sub,
        memberHash: hash,
        profile: {
          ...(env !== "prd" && { env }),
          userId: accessToken.sub,
          userType: accessToken.userType,
          userGroups: accessToken.userGroups ?? [],
          userStatus: accessToken.userStatus,
          hasCustomDiscount: accessToken.hasCustomDiscount ?? false,
          customerId: accessToken.customerId,
          studentId: accessToken.studentId ?? null,
        },
      });
    } else {
      ChannelService.boot({
        pluginKey: "14123e3e-8cd8-4698-98a9-3af097115ea5",
        profile: {
          userType: "비회원",
        },
      });
    }
    return () => ChannelService.shutdown();
  }, [token]);

  return <></>;
};

export default ChannelTalk;
